/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigurationParametersSchema } from './ConfigurationParametersSchema';
import {
    ConfigurationParametersSchemaFromJSON,
    ConfigurationParametersSchemaFromJSONTyped,
    ConfigurationParametersSchemaToJSON,
} from './ConfigurationParametersSchema';

/**
 * Request schema for creating/updating a configuration.
 * Exactly one of shape_uuid or geometry must be provided.
 * @export
 * @interface ConfigurationRequestSchema
 */
export interface ConfigurationRequestSchema {
    /**
     * Name of the configuration
     * @type {string}
     * @memberof ConfigurationRequestSchema
     */
    name: string;
    /**
     * Whether the configuration is enabled
     * @type {boolean}
     * @memberof ConfigurationRequestSchema
     */
    enabled?: boolean;
    /**
     * 
     * @type {ConfigurationParametersSchema}
     * @memberof ConfigurationRequestSchema
     */
    parameters: ConfigurationParametersSchema;
    /**
     * Severity level
     * @type {string}
     * @memberof ConfigurationRequestSchema
     */
    severity?: string;
    /**
     * UUID reference to a shape
     * @type {string}
     * @memberof ConfigurationRequestSchema
     */
    shapeUuid?: string | null;
    /**
     * Geojson data of the configuration
     * @type {{ [key: string]: any; }}
     * @memberof ConfigurationRequestSchema
     */
    geometry?: { [key: string]: any; } | null;
    /**
     * Access control list (read)
     * @type {Array<string>}
     * @memberof ConfigurationRequestSchema
     */
    acl?: Array<string>;
    /**
     * Access control list (write)
     * @type {Array<string>}
     * @memberof ConfigurationRequestSchema
     */
    aclPut?: Array<string>;
    /**
     * Configuration type
     * @type {string}
     * @memberof ConfigurationRequestSchema
     */
    type?: string;
    /**
     * Phone numbers for notifications
     * @type {Array<string>}
     * @memberof ConfigurationRequestSchema
     */
    phoneNumbers?: Array<string>;
    /**
     * Email addresses for notifications
     * @type {Array<string>}
     * @memberof ConfigurationRequestSchema
     */
    emailAddresses?: Array<string>;
    /**
     * Whether to exclude port areas from the configuration geometry
     * @type {boolean}
     * @memberof ConfigurationRequestSchema
     */
    excludePorts?: boolean;
}

/**
 * Check if a given object implements the ConfigurationRequestSchema interface.
 */
export function instanceOfConfigurationRequestSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "parameters" in value;

    return isInstance;
}

export function ConfigurationRequestSchemaFromJSON(json: any): ConfigurationRequestSchema {
    return ConfigurationRequestSchemaFromJSONTyped(json, false);
}

export function ConfigurationRequestSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationRequestSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'parameters': ConfigurationParametersSchemaFromJSON(json['parameters']),
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'shapeUuid': !exists(json, 'shape_uuid') ? undefined : json['shape_uuid'],
        'geometry': !exists(json, 'geometry') ? undefined : json['geometry'],
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'aclPut': !exists(json, 'acl_put') ? undefined : json['acl_put'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'phoneNumbers': !exists(json, 'phone_numbers') ? undefined : json['phone_numbers'],
        'emailAddresses': !exists(json, 'email_addresses') ? undefined : json['email_addresses'],
        'excludePorts': !exists(json, 'exclude_ports') ? undefined : json['exclude_ports'],
    };
}

export function ConfigurationRequestSchemaToJSON(value?: ConfigurationRequestSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'enabled': value.enabled,
        'parameters': ConfigurationParametersSchemaToJSON(value.parameters),
        'severity': value.severity,
        'shape_uuid': value.shapeUuid,
        'geometry': value.geometry,
        'acl': value.acl,
        'acl_put': value.aclPut,
        'type': value.type,
        'phone_numbers': value.phoneNumbers,
        'email_addresses': value.emailAddresses,
        'exclude_ports': value.excludePorts,
    };
}

